/** The merchant app's Verify your business page for Redo-owned Adyen onboarding; each click there mints a fresh Adyen link. */
export function hsaAdyenKycPath(teamId: string): string {
  return `/stores/${teamId}/payments/kyc`;
}
